<article class="card" [class]="'card ' + toneClass()">
  <header class="head">
    <div class="title"><ng-content select="[card-title]" /></div>
    <div class="status">
      <span class="badge">{{ badge() }}</span>
      <ng-content select="[card-badge-extra]" />
    </div>
  </header>

  @if (staleAge(); as age) {
    <p class="stale">
      <strong>Data from {{ age }}.</strong> The latest check could not read new data, so this is the
      last reading we have.
    </p>
  }

  <ng-content />

  <footer class="foot">
    @if (portalUrl(); as url) {
      <a class="portal" [href]="url" target="_blank" rel="noopener noreferrer"
        >Open in Azure portal<span class="visually-hidden"> (opens in a new tab)</span></a
      >
    }
    <div class="meta"><ng-content select="[card-meta]" /></div>
  </footer>
</article>
